module App.Classes {
    export interface ICompositionResult {
        composition: IComposition;
        pipeline: string;
        operation: string;
        operationValue: object;
        error: boolean;
        skipSteps: string[];
    }

    export class CompositionResult implements ICompositionResult {
        composition: IComposition;
        pipeline: string;
        operation: string;
        operationValue: object;
        error: boolean;
        skipSteps: string[];

    }
}